export function extend(target) {
  for (let i = 1; i < arguments.length; i++) {
    for (const prop in arguments[i]) {
      target[prop] = arguments[i][prop]
    }
  }
  return target
}
